
// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import Logo_Youteach from 'ui-component/Logo_Youteach';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link href={DASHBOARD_PATH} aria-label="Youteach.AI logo" style={{ minHeight: '48px' }}>
        <Logo_Youteach />
        {/* <Logo /> */}
        {/* <Button style={{margin: 5, height: 50}} variant="outlined" color="secondary">
            YouTeach.AI
        </Button>         */}
    </Link>
);

export default LogoSection;
